import { PRE_PROD } from './env';
import { getCookieObject } from './cookieUtils';
import { getLocationSearch } from './locationUtils';

export const FIVE9_WEBCHAT_VISITOR_TYPES = {
  travelAgent: 'travelAgent',
  easybiz: 'easybiz',
  default: 'default',
};

/**
 * Determine visitor type by cookie auth
 * @returns {string} enumerable visitor type
 */
export const getVisitorType = () => {
  const travelAgentCookie = getCookieObject('AS%5FPROMO%5FLOGIN');
  const easyBizCookie = getCookieObject('AS%5FACNT%5FCOMPANY');
  const locationSearch = getLocationSearch();
  let visitorType = FIVE9_WEBCHAT_VISITOR_TYPES.default;
  let overrideMatch;

  if (PRE_PROD() && locationSearch?.match(/visitor=([^&]+)/)) {
    overrideMatch = locationSearch?.match(/visitor=([^&]+)/);
    const overrideVisitor =
      overrideMatch.length > 1 && FIVE9_WEBCHAT_VISITOR_TYPES[overrideMatch[1]];
    return overrideVisitor || FIVE9_WEBCHAT_VISITOR_TYPES.default;
  }
  if (
    (locationSearch && /lid=TAfooter/i.test(locationSearch)) ||
    (travelAgentCookie?.STATUS === 'OK' &&
      travelAgentCookie?.TYPE === 'TRAVELAGENT')
  ) {
    visitorType = FIVE9_WEBCHAT_VISITOR_TYPES.travelAgent;
  } else if (easyBizCookie?.COMPANYNAME) {
    visitorType = FIVE9_WEBCHAT_VISITOR_TYPES.easybiz;
  }
  return visitorType;
};
